import Indicadores from '@/services/Indicadores'
export default {
    getSectorLevel(stageId, typeId){
        return Indicadores().get('sector/sectors-type/'+stageId+'/'+typeId)
    },
    getSectorLevelHospital(stageId, typeId, hospitalId){
        return Indicadores().get('sector/filter/stage/'+stageId+'/type/'+typeId+'/hospital/'+hospitalId)
    },
    getSectorTreeView(id){
        return Indicadores().get('sector/treeview/'+id)
    },
    getSectorTreeViewHierarchy(id){
        return Indicadores().get('sector/treeview-hierarchy/'+id)
    },
    getSectorMaster(stage){
        return Indicadores().get('sector/treeview-master/'+stage)
    },
    getSectorChildren(id){
        return Indicadores().get('sector/treeview-children/'+id)
    },
     getChildSectors(sectorId, stageId) {
    return Indicadores().get(`sector/children/all/${sectorId}/stage/${stageId}`)
    },
    getAllChildrenInstance(id, stageId, periodId, cancelSignal) {
        return Indicadores().get(`sector/children/all/${id}/stage/${stageId}/period/${periodId}`, { signal: cancelSignal })
    },
    getSectorByFather(id){
        return Indicadores().get('sector/treeview-father/'+id)
    },
    get(id){
        return Indicadores().get('sector/data/'+id)
    },
    getNano(id){
        return Indicadores().get('sector/data/nano/'+id)
    },
    getInPeriod(id, periodId){
        return Indicadores().get('sector/data/'+id+'/period/'+periodId)
    },
    getObjectives(id){
        return Indicadores().get('objective/sector/'+id)
    },
    getSectorTypeCompany(id){
        return Indicadores().get('sector/type/'+id)
    },
    createSector(data){
        return Indicadores().post('sector/save',data)
    },
    updateSector(data){
        return Indicadores().post('sector/update',data)
    },
    deleteSector(sectorId){
        return Indicadores().delete('sector/delete/'+sectorId)
    },
    getSectoresScore(idGerencia, stageId, periodId){
        return Indicadores().get('sector/children/' + idGerencia + '/stage/' + stageId + '/period/'+periodId)
        //return Indicadores().get('sector/report/score/sector-father/'+idGerencia+'/period/'+periodId)
    },
    calcScore(sector, period){
        return Indicadores().get('sector/procedure/calculate/score/'+sector+'/'+period)
    },
    calcMeasuresFromChild(sector, period){
        return Indicadores().get('sector/procedure/calculate/father/'+sector+'/'+period)
    },

    getDefaultGrades(stage){
        return Indicadores().get("grade/list/"+stage);
    },
    getSectorByChild(sectorId){
        return Indicadores().get("sector/data/"+sectorId+"/father");
    },
    getChildren(id, stage){
        return Indicadores().get('sector/children/'+id+ '/stage/' + stage);
    },
    async getScore(sectorId, periodId){
        const sector = await this.get(sectorId);
        const listScores = sector.data.scores;
        return listScores.find(x=>x.periodId===periodId) || {id:null, points:null, grade: null};
    },
    fixPoints(sectorId, recursive){
        if(recursive){
            return Indicadores().post("sector/fix/point-recursive/"+sectorId);
        }else{
            return Indicadores().post("sector/fix/point/"+sectorId);
        }
    },
    recalcMeasurePoints(sectorId, periodId){
        return Indicadores().post("sector/recalc/measure-points/"+sectorId+"/period/"+periodId)
    },
    getScores(sectorId, periodId, all){
        if(all){
            return Indicadores().get(`score/period/${periodId}/sector/${sectorId}/all`);
        }
        return Indicadores().get(`score/period/${periodId}/sector/${sectorId}`);
    },
    closeSector(sectorId, periodId, recursive){
        if(recursive){
            return Indicadores().post(`sector/close/sector/${sectorId}/period/${periodId}/recursive`);
        }else{
            return Indicadores().post(`sector/close/sector/${sectorId}/period/${periodId}`);
        }
    }
}

